export function isSSR() {
  return typeof document === 'undefined';
}

export default isSSR;
